/**
 * The Query Tool's origin from the build (`REACT_APP_QUERY_TOOL_URL`), or null when it is unset or
 * not an http(s) URL. Null switches the in-app CENTERLINE AI chat off: no route, no nav entry, and no
 * request to the Query Tool or to CENTERLINE's token endpoint.
 */
export function queryToolBaseUrl(raw: string | undefined): string | null {
  const value = (raw ?? '').trim().replace(/\/+$/, '');
  if (!/^https?:\/\/[^\s/]+/i.test(value)) return null;
  return value;
}

/** The hidden run-options bar (model, thinking, steps) is shown only with this build flag. */
export const runOptionsVisible = (raw: string | undefined): boolean => raw === 'true';

/** The dictation (microphone) button in the composer is built only with this flag. */
export const voiceInputEnabled = (raw: string | undefined): boolean => raw === 'true';

/** With this flag too, dictation is offered only where the browser can recognise speech on the device. */
export const voiceLocalOnly = (raw: string | undefined): boolean => raw === 'true';
